import angular from 'angular';

angular.module('cloudX').component('cxRelFieldSearch', {
  require: {
    relFileCtrl: '^cxRelationFile',
  },
  bindings: {
    sections: '<',
  },
  template: require('./relFieldSearch.html'),
  controllerAs: 'vm',
  controller: [
    'translateListFilter',
    '$timeout',
    '$anchorScroll',
    function(translateListFilter, $timeout, $anchorScroll) {
      const vm = this;
      vm.searchValue = null;
      vm.fields = [];
      vm.show = false;

      vm.gotoField = field => {
        if (!vm.relFileCtrl) return;
        const { fieldId, mainSectionId, parentSections } = field;
        if (!fieldId) return;
        const [lastSection] = parentSections.slice(-1) || [];
        if (mainSectionId && lastSection) {
          return vm.relFileCtrl.openSection(mainSectionId).then(() => {
            return $timeout(function() {
              $anchorScroll(`${lastSection.id}-${fieldId}`);
              vm.searchValue = null;
            }, 500);
          });
        }
        vm.relFileCtrl.gotoField(fieldId).then(() => {
          vm.searchValue = null;
        });
      };

      const extractFieldsFromColumn = (column, parentInfo) => {
        if (!column || column.length === 0) return [];
        return column.map(x => ({
          ...parentInfo,
          fieldId: x.id,
          fieldLabel: x.label,
          fieldType: x.type,
          isList: x.isList,
          label: translateListFilter(x.id, 'field', x.label),
        }));
      };
      const extractFieldsFromListField = (list, parentInfo) => {
        if (!list) return [];
        return {
          ...parentInfo,
          fieldId: list.id,
          fieldLabel: list.label,
          fieldType: list.type,
          isList: list.isList,
          label: translateListFilter(list.id, 'field', list.label),
        };
      };
      const extractFieldsFromSection = (
        section,
        { parentSections = [], mainSectionId, ...parentInfo } = {},
      ) => {
        if (!section) return [];

        const info = {
          ...parentInfo,
          parentSections: [
            ...parentSections,
            {
              id: section.id,
              label: translateListFilter(section.id, 'section', section.label),
            },
          ],
          mainSectionId: mainSectionId || section.id,
        };

        return [
          ...(section.lists ? section.lists.flatMap(x => extractFieldsFromListField(x, info)) : []),
          ...(section.columns
            ? section.columns.flatMap(x => extractFieldsFromColumn(x, info))
            : []),
          ...(section.sections
            ? section.sections.flatMap(x => extractFieldsFromSection(x, info))
            : []),
        ];
      };

      vm.reloadFields = function() {
        if (!vm.sections) {
          vm.fields = [];
          vm.show = false;
          return;
        }

        vm.fields = vm.sections.flatMap(x => extractFieldsFromSection(x));
        vm.show = vm.fields && vm.fields.length > 0;
        //console.log(vm.fields);
      };

      vm.$onChanges = function() {
        vm.reloadFields();
      };
    },
  ],
});
